/* eslint import/prefer-default-export: 0 */
import { createAsyncRequestTypes } from 'utils'

const AUDITS = '@@AUDITS@@/'

/* list audits */
export const LIST_AUDITS = createAsyncRequestTypes(`${AUDITS}/LIST_AUDITS`)
